module.exports = __webpack_public_path__ + "list.ec8f4f17.gif";